export { registerTour, getTour, getAllTours, getToursByRole, getToursByProduct, getFilteredSteps } from './registry';
export type { TourConfig, TourStep, TourStepRoleVariant, TourPlacement, ActiveTour } from './types';

// Register all built-in tours
import { registerTour } from './registry';
import { gettingStartedTour } from './tours/getting-started';

registerTour(gettingStartedTour);
